module.exports = __webpack_public_path__ + "static/img/信息5.07ae50e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息5.png
// module id = KTd7
// module chunks = 1